/**
 * The words of the boot-failure page (content rules: what happened, then what to do).
 *
 * A module of its own, with no imports, so the two screens that show them share
 * them without either importing the other: bootFailure.tsx (the house
 * StandalonePage) and main.tsx's plain-DOM last resort, which must import nothing
 * that could be what failed.
 */

export const BOOT_FAILURE_TEXT = {
    title: "The console could not start",
    intro: "A setting the console needs is missing or wrong. This is not something you did: the setup is not finished.",
    help: "For the admin: copy console/.env.example to .env.local, fill in the values, then build again."
} as const;
